import { classes, media, stylesheet } from 'typestyle';
import { Gray20, Search, Select } from '@traceair/tds';
import { FilterIcon } from '@traceair/webapp-icons';
import { BREAKPOINT_SMALL } from '../../../layout/styles';
import { useSelectedMissionsTab } from '../useSelectedMissionsTab';
import { useAppStore } from '../../../../store/appStore';
import { MissionType } from '../../../../consts/missionType';
import { MissionTab } from '../../../../consts/missionTab';

const css = stylesheet({
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    flex: '0 0 100%',
    padding: '12px 0 0',
    margin: '12px 0 0',
    borderTop: `1px solid ${Gray20}`,
    ...media(
      { maxWidth: BREAKPOINT_SMALL },
      {
        marginTop: 0,
        border: 'none',
      },
    ),
  },
  type: {
    width: 220,
    ...media(
      { maxWidth: BREAKPOINT_SMALL },
      {
        display: 'none',
      },
    ),
  },
  search: {
    width: 286,
    ...media(
      { maxWidth: BREAKPOINT_SMALL },
      {
        width: '100%',
      },
    ),
  },
  searchFullWidth: {
    $nest: {
      '&&': {
        width: '100%',
      },
    },
  },
  searchField: {
    width: '100%',
  },
});

export const MissionFilters = () => {
  const { missionFilter, projectSearch, setMissionFilter, setProjectSearch } = useAppStore();
  const selectedMissionsTab = useSelectedMissionsTab();
  const areSchedulesSelected = selectedMissionsTab === MissionTab.Schedules;

  const handleFilterChange = (value: MissionType) => {
    setMissionFilter(value);
  };

  const handleSearchChange = (value: string) => {
    setProjectSearch(value);
  };

  const handleSearchClear = () => {
    setProjectSearch(null);
  };

  return (
    <div className={css.container} data-intercom-target="MissionFilters">
      {areSchedulesSelected && (
        <div className={css.type}>
          <Select
            allowClear
            label="Missions with"
            icon={<FilterIcon />}
            placeholder="All missions"
            onChange={handleFilterChange}
            value={missionFilter ?? undefined}
            options={Object.values(MissionType).map((value) => ({
              label: value,
              value,
            }))}
          />
        </div>
      )}

      <div className={classes(css.search, !areSchedulesSelected && css.searchFullWidth)}>
        <Search
          className={css.searchField}
          placeholder="Search for project"
          value={projectSearch ?? undefined}
          onChange={handleSearchChange}
          onClear={handleSearchClear}
        />
      </div>
    </div>
  );
};
